import React from 'react'

function QandA() {
  return (
    <h5 style={{paddingLeft:"20%"}}> QandA</h5>
  )
}

export default QandA